<template>
  <v-list-item link :to="to" :disabled="disabled">
    <v-list-item-action>
      <v-icon>{{icon}}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-bind:class="{ 'font-italic': child }">{{title}}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'nav-item',
  props: [ 'to', 'icon', 'title', 'child', 'disabled' ]
}
</script>
